import React, { Component } from 'react'

import LoaderButton from './loaderButton'
import { ReduxFormProps } from '../forms'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { withRouter } from 'react-router-dom'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  onSubmit: Callback<Promise<any>>
  onTitleChange: Callback
  onDescriptionChange: Callback
  onModeChange: Callback
  cancel: Callback
}

export interface FormProps {
  title: string
  description: string
  mode: 'image' | 'text'
}

export class RefiCustomToDoForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'RefiCustomToDoForm'

  render() {
    const {
      handleSubmit,
      submitting,
      cancel,
      onTitleChange,
      onDescriptionChange,
      onModeChange,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit}
        className="form"
        data-test="refi-custom-todo-form"
      >
        <div className="refi-custom-todo-form">
          <h2>Add Custom Todo</h2>
          <div>
            <label htmlFor="title" style={{ display: 'block' }}>
              Title
            </label>
            <input type="text" name="title" onChange={onTitleChange} />
          </div>
          <div>
            <label htmlFor="description" style={{ display: 'block' }}>
              Description
            </label>
            <textarea name="description" onChange={onDescriptionChange} />
          </div>
          <div>
            <label htmlFor="mode" style={{ display: 'block' }}>
              Mode
            </label>
            <select onChange={onModeChange}>
              <option>image</option>
              <option>text</option>
            </select>
          </div>
          <hr className="form__hr" />
          <div className="form__group actions">
            <LoaderButton
              className="button button--primary"
              isLoading={submitting}
              disabled={submitting}
              data-test="refi-custom-todo-form-submit-button"
            >
              Save
            </LoaderButton>
            <a
              onClick={cancel}
              className="button button--secondary"
              data-test="refi-custom-todo-form-cancel-button"
              aria-label="cancel"
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    )
  }
}

const RefiCustomToDoFormWithRouter = withRouter(
  reduxForm<FormProps, Props>({
    form: 'RefiCustomToDoForm',
  })(RefiCustomToDoForm)
)

const selector = formValueSelector('RefiCustomToDoForm')
const RefiCustomToDoFormConnected = connect((state) => {
  const price = selector(state, 'price')
  return { price }
})(RefiCustomToDoFormWithRouter)

export default RefiCustomToDoFormConnected
